import { FlowDesignClient } from '@zap-onboard/api-client';
import { useHandlerQuery } from '../../useHandlerQuery';

export const useFlowDesigns = (
  ...args: Parameters<FlowDesignClient['getFlowDesigns']>
) =>
  useHandlerQuery((api) => api.flowDesigns().getFlowDesigns(...args), {
    key: ['FLOW_DESIGNS', args[0]],
  });
